import StyledDialog from "components/Styled/Dialog";

interface Props {
  children: React.ReactNode;
  handleClose?: () => void;

  isDialog?: boolean;
}

const CreateTemplateDialogWrapper = ({
  children,
  handleClose,
  isDialog,
}: Props) => {
  if (!isDialog) {
    return <>{children}</>;
  }
  return (
    <StyledDialog title="" open={true} handleClose={handleClose}>
      {children}
    </StyledDialog>
  );
};

export default CreateTemplateDialogWrapper;
